<template>
	<section
		v-if="filteredComments && filteredComments.length > 0"
		class="comments-list my-[32px]"
	>
		<Heading
			tag="h5"
			:text="`Comments (<span class='text-primary-500'>${comments.length}</span>)`"
			class="mb-[32px]"
		/>

		<div
			class="comments-container"
			:class="{ hidden: !displayComments && comments.length > 5 }"
		>
			<Comment
				v-for="comment in filteredComments"
				:key="comment.commentId"
				v-bind="comment"
				:author="comment.author"
			/>
		</div>

		<button
			class="btn primary px-[24px] mt-[16px]"
			@click="displayComments = true"
			v-if="!displayComments && comments.length > 5"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height="24"
				viewBox="0 -960 960 960"
				width="24"
				class="fill-white mr-[8px]"
			>
				<path
					d="M240-400h480v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM880-80 720-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v720ZM160-320h594l46 45v-525H160v480Zm0 0v-480 480Z"
				/>
			</svg>
			See more
		</button>
	</section>
</template>

<script setup>
const { comments } = defineProps({
	comments: {
		type: Array,
		required: true
	}
});
const displayComments = ref(false);

const filteredComments = computed(() => {
	let arr = comments.filter(
		(comment) => !comment.parentDatabaseId || comment.parentDatabaseId === 0
	);
	arr = arr.filter(
		(comment, index) => index === 0 || arr[index - 1].content !== comment.content
	);

	return arr;
});
</script>

<style lang="scss" scoped>
@import "@assets/utils.scss";

.comments-list {
	display: inline-block;
	width: 100%;
	overflow-x: hidden;
}

.select-dropdown {
	color: $neutral-800;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	height: 30px;
}

.select-dropdown-input {
	background-color: transparent;
	font-weight: 600;
}

.btn {
	display: flex;
	padding: 8px 16px;
	min-height: 40px;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	font-family: Rubik;
}

.comments-container.hidden {
	height: 720px;
	overflow: hidden;
	position: relative;
	&::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 140px;
		width: 100%;
		background: linear-gradient(
			180deg,
			rgba(255, 255, 255, 0) 10%,
			$primary-50 80%
		);
	}
}
.primary {
	color: $neutral-100;
	text-align: center;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	letter-spacing: 0.18px;
	background: $primary-500;
	&:hover {
		background-color: $primary-700;
	}
}
</style>
